import { ElementType } from 'react';
import clsx from 'clsx';
import { Link, LinkProps } from 'react-router-dom';
import styles from './ButtonLink.module.css';

type TProps = {
  icon?: ElementType;
  className?: string;
  linkClassName?: string;
  iconPosition?: 'left' | 'right';
  linkProps?: LinkProps;
  href?: string;
  inline?: boolean;
} & React.ComponentProps<'button'>;

export const ButtonLink = ({
  icon: Icon,
  children,
  className,
  iconPosition = 'right',
  linkProps,
  linkClassName,
  href,
  inline = false,
  ...props
}: TProps) => {
  const iconComponent = Icon ? <Icon className={styles.icon} /> : undefined;

  const component = (
    <button
      className={clsx(
        styles.buttonLink,
        { [styles.isInline]: inline },
        className,
      )}
      {...props}
    >
      {iconPosition === 'left' && iconComponent}
      {children}
      {iconPosition === 'right' && iconComponent}
    </button>
  );

  if (linkProps || href) {
    return (
      <Link
        to={href as string}
        className={clsx(styles.linkWrapper, linkClassName)}
        {...linkProps}
      >
        {component}
      </Link>
    );
  }
  return component;
};
